import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

const SimpleLineChart = ({ partsDataMap, dateMap }) => {
  const oeeeList = partsDataMap?.oeeList || [];
 
  // Ensure each list has the same length
  const maxLength = Math.max(oeeeList.length);

  // Process the data to create the desired format
  const data = Array.from({ length: maxLength }, (_, index) => {
    const sum =
      (oeeeList[index] || 0) 
      // (oeeeList2[index] || 0) +
      // (oeeeList3[index] || 0);

    const average = sum ; // Divide by the number of lists

    const dateTime = dateMap.dateTimeList[index] || '';

    return {
      name: dateTime,
      oee: isNaN(average) ? 0 : average,
    };
  });

  // console.log(data);


  return (
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer>
        <LineChart
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />

          <Line type="monotone" dataKey="oee" stroke="#82ca9d" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default SimpleLineChart;